export default "__VITE_ASSET__0cffbf30__"